/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import i18next from 'i18next';
import type { VisitFormData } from './schema';

const FIELD_KEYS: Array<{ key: keyof VisitFormData; labelKey: string }> = [
  { key: 'propertyId', labelKey: 'fieldLabels.property' },
  { key: 'clientId', labelKey: 'fieldLabels.client' },
  { key: 'visitDate', labelKey: 'fieldLabels.date' },
  { key: 'visitTime', labelKey: 'fieldLabels.time' },
  { key: 'brokerEmail', labelKey: 'fieldLabels.broker' },
];

/**
 * Resolves the localized labels of the required visit fields that currently
 * have a validation error.
 *
 * @param errors - The form's error map keyed by field name, or null/undefined.
 * @returns The translated labels of the missing/invalid fields.
 */
export function getMissingFieldLabels(errors: Record<string, unknown> | undefined | null): string[] {
  if (!errors) return [];
  return FIELD_KEYS
    .filter(({ key }) => Boolean(errors[key]))
    .map(({ labelKey }) => i18next.t(labelKey, { ns: 'features/visits' }));
}
